import {
    InventoryLocationInteraction,
    InventoryLocationInteractionMode
} from "./interaction";
import {drawInventoryLocationStyle} from "../../../../map/styles/inventory-locations";
import {EpInventoryLocations} from "../../../../map/layers/inventory-locations";
import {Collection} from "ol";
import * as turf from "@turf/turf";
import * as $ from "jquery";
import GeoJSON from 'ol/format/GeoJSON';
import {booleanPointInPolygon, point, polygon} from '@turf/turf';
import { transform } from 'ol/proj';

export class InventoryLocationInteractionLocation extends InventoryLocationInteraction {
    /**
     * @param {InventoryLocationInteractionsHandler} handler
     */
    constructor(handler) {
        const layer = new EpInventoryLocations(handler.epMap.map);
        layer.farStyle = null;
        layer.name = 'interaction_location';

        handler.epMap.addCustomLayer(layer)

        super('location', handler, layer);

        this.dictionary = {
            [InventoryLocationInteractionMode.DRAW]: 'Rysuj obszar',
            [InventoryLocationInteractionMode.EDIT]: 'Edytuj obszar',
            deleteConfirm: 'Czy na pewno chcesz usunąć obszar?',
        };

        this.createFeatureFromInput();
        this.updateAreaInfo();
    }

    draw() {
        super.draw();
        let that = this;

        this.handler.epMap.helpTooltip.set('Aby zakończyć rysowanie, kliknij w pierwszy dodany punkt.');
        this.addOlInteraction(
            this.epLayer.addDraw({
                noSource: true,
                style: drawInventoryLocationStyle,
                condition: (e) => {
                    let features = this.handler.epMap.getOlMap().getFeaturesAtPixel(e.pixel, {
                        layerFilter: (layer) => {
                            return layer === this.handler.epMap.boundaries.getLayer();
                        }
                    });
                    return features.length > 0;
                },
                end: function (e) {

                    that.getDevices(e.feature);
                    that.addFeature(e.feature);
                    that.handler.setCurrentInteraction(null);

                }
            })
        )
    }

    edit() {
        super.edit();

        let that = this;
        let previousCoordinates = this.features[0].getGeometry().getCoordinates();

        this.addOlInteraction(
            this.epLayer.addEdit({
                style: drawInventoryLocationStyle,
                features: new Collection(this.features),
                end: function (e) {
                    let feature = e.features.item(0);

                    if (
                        !turf.booleanWithin(
                            turf.polygon(feature.getGeometry().getCoordinates()),
                            that.handler.epMap.boundaries.getBufferedBoundariesPolygon(2)
                        )
                    ) {
                        feature.getGeometry().setCoordinates(previousCoordinates);
                        return;
                    }

                    that.getDevices(feature);
                    that.updateFeature(feature);
                    that.updateAreaInfo();
                    previousCoordinates = feature.getGeometry().getCoordinates();
                }
            })
        )
    }

    end(forced) {
        super.end(forced);
        this.updateAreaInfo();

        let type = JSON.parse(window._location_type);

        if(parseInt(type) === 2){
            $('#btnSaveLocations').click();
        }
    }

    updateAreaInfo() {
        const form = $('body').find('#addLocation, #editLocation');
        const areaInput = form.find('[name="area"]')
        const areaChangedManually = form.find('[name="area_changed_manually"]')

        if (this.features.length) {
            // if (parseInt(areaChangedManually.val()) === 0 || areaInput.val().length === 0) {
            //     areaInput.val((getArea(this.features[0].getGeometry()) / 10000).toFixed(2))
            // }
        }
    }

    getDevices(feature){

        let confirmed = true;

        let devices = JSON.parse(window._allDevices ?? '[]');
        let devicesOfChoice = [];
        const drawnGeometry = feature.getGeometry();
        const geoJsonGeometry = new GeoJSON().writeGeometry(drawnGeometry);

        const geoJsonObject = JSON.parse(geoJsonGeometry);
        const coordinates = geoJsonObject.coordinates;

        const turfPolygon = polygon(coordinates);

        if (confirmed) {
            devices.forEach(device => {
                if(device.latitude && device.longitude){
                    const longitude = parseFloat(device.longitude);
                    const latitude = parseFloat(device.latitude);

                    if (!isNaN(longitude) && !isNaN(latitude)) { // Ensure both coordinates are valid numbers
                        const devicePoint = point([longitude, latitude]);
                        const devicePoint3857 = point(
                            transform(devicePoint.geometry.coordinates, 'EPSG:4326', 'EPSG:3857')
                        );

                        if (booleanPointInPolygon(devicePoint3857, turfPolygon)) {
                            devicesOfChoice.push(device);
                        }
                    } else {
                        console.warn(`Device with ID ${device.id} has invalid coordinates and will be skipped.`);
                    }
                }
            });
        }

        let type = JSON.parse(window._location_type);

        if(parseInt(type) === 2){
            $('input[name="locationDevices"]').val(JSON.stringify(devicesOfChoice));
        }

    }
}